import { notificationsConfigAxios } from '@/utils/api-instance';
import { ENDPOINTS } from '@/utils/constants';

export const sendViewNewTabEngelinkMarketing = async () => {
    const api = notificationsConfigAxios();
    await api.put(ENDPOINTS.NOTIFICATION_READ);
};

export const checkViewNewTabEngelinkMarketing = async () => {
    const api = notificationsConfigAxios();
    const { data } = await api.get(ENDPOINTS.NOTIFICATION_HAS_NEW);
    return data;
};

export const getCountNotificationUnread = async () => {
    const api = notificationsConfigAxios();
    const { data } = await api.get(`notifications/${ENDPOINTS.COUNT_NOTIFICATION_UNREAD}`);
    return data;
};

export const getAllNotifications = async (query) => {
    const api = notificationsConfigAxios();
    const { data } = await api.get(`notifications${query}`);
    return data;
};

export const setNotificationsRead = async () => {
    const api = notificationsConfigAxios();
    const { data } = await api.put(`notifications/${ENDPOINTS.MARK_ALL_READ}`);
    return data;
};